module.exports = __webpack_public_path__ + "img/tutorial_main_03.cd516db5.jpg";